import { parseUrl, stringify } from 'query-string';

interface IOptimizedUrlOptions {
	url: string;
	height?: number;
	width?: number;
	isCroped?: boolean;
	isRetina?: boolean;
}

export const getOptimizedImageUrl = (options: IOptimizedUrlOptions): string => {
	const { url, width, height } = options;
	let { isCroped, isRetina } = options;
	const { url: shortUrl, query } = parseUrl(url);

	isCroped = isCroped === undefined ? true : isCroped;
	isRetina = isRetina === undefined ? true : isRetina;

	const newQuery = stringify({
		...query,
		mh: height ? (isRetina ? height * 2 : height) : undefined,
		mw: width ? (isRetina ? width * 2 : width) : undefined,
		croped: isCroped ? 1 : undefined,
	});

	return `${shortUrl}?${newQuery}`;
};
